import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { ReactComponent as WarningBlue } from 'assets/icons/warning-blue.svg';
import { ReactComponent as WarningRed } from 'assets/icons/warning-red.svg';
import { Modal, TextAreaField, Label } from 'components';
import { isInvestor,  outcomes,isRejectedStatus, isSubmitter, isObjectionCommittee } from 'utils';
import { radioOptions } from './utils';
import { updateFormField } from 'store/forms/actions';
import { Radio } from 'antd';
import isEmpty from 'lodash/isEmpty';
import { isBeneficiary, isAuditor } from 'utils';

const SubmitModal = ({
  isVisible,
  setIsVisible,
  handleSubmit,
  handleCarrierUsers,
  submitDisabled,
  formKey,
  outcome,
  businessKey,
}) => {
  const dispatch = useDispatch();
  const returnAuditorMessage = useSelector(state => state.forms?.auditor?.returnAuditorMessage);
  const user = useSelector(state => state.user);
  const taskName = useSelector(state => state.forms.task.taskName);
  const rejectImplementer = outcome === outcomes.rejectImplementer;
  const returnAuditor = outcome === outcomes.returnAuditor;
  const cancelBeneficiary = outcome === outcomes.cancelBeneficiary;
  const submitAuditor = outcome === outcomes.approveImplementer;
  const rejectObjection = outcome === outcomes.rejectObjection;
  const acceptObjection = outcome === outcomes.acceptObjection;
  const updateCarrierUsers = outcome === outcomes.updateCarrierUsers;

  const renderContent = () => {
    if (isBeneficiary(user?.groups)) {
      if ( (taskName === "task.name.submit_application" || taskName === "task.name.application_returned_to_supplier") && !cancelBeneficiary ){
        return (
          <div>
            <div className="content-title color-blue-3 font-size-24 mb-2">
            Υποβολή Αίτησης
          </div>Πρόκειται να υποβάλετε αίτηση για την ένταξή σας στο μητρώο προμηθευτών  του Προγράμματος "Αλλάζω Σύστημα Θέρμανσης και Θερμοσίφωνα". Παρακαλούμε επιβεβαιώστε την ενέργεια διαφορετικά επιλέξτε Ακύρωση. 
          </div>
        )
      } else if (taskName === "task.name.submit_application" && !cancelBeneficiary ) {
        return (
          <div>
            <div className="content-title color-blue-3 font-size-24 mb-2">
            Ακύρωση Αίτησης
          </div>Με την ενέργεια αυτή πρόκειται να ακυρώσεται την αίτηση σας. Η ενέργεια αυτή είναι μή αναστρέψιμη. Παρακαλούμε επιβεβαιώστε την ενέργεια διαφορετικά επιλέξτε Ακύρωση. 
          </div>
        )
      } else if ( (taskName === "task.name.temporary_rejected")){
        return (
          <div>
            <div className="content-title color-blue-3 font-size-24 mb-2">
            Υποβολή Ένστασης
          </div>Πρόκειται να υποβάλετε αίτημα επανεξέτασης. Η ενέργεια είναι μη αναστρέψιμη. Επιλέξτε το "Επιβεβαίωση" αν επιθυμείτε να συνεχίσετε διαφορετικά επιλέξτε "Ακύρωση".</div>
        )
      } else if ( (taskName === "task.name.accepted")){
        return (
          <div>
            <div className="content-title color-blue-3 font-size-24 mb-2">
            Ανανέωση Χρηστών
          </div>Πρόκειται να προβείτε σε ανανέωση της λίστας των δηλωμένων Χρηστών. Επιλέξτε το "Επιβεβαίωση" αν επιθυμείτε να συνεχίσετε διαφορετικά επιλέξτε "Ακύρωση".</div>
        )
      }    
      else {
        return (
          <div>
            <div className="content-title color-blue-3 font-size-24 mb-2">
            Ακύρωση Αίτησης 2
          </div>Με την ενέργεια αυτή πρόκειται να ακυρώσεται την αίτηση σας. Η ενέργεια αυτή είναι μή αναστρέψιμη. Παρακαλούμε επιβεβαιώστε την ενέργεια διαφορετικά επιλέξτε Ακύρωση. 
          </div>
        )
      }
    } else if(isAuditor(user?.groups) && returnAuditor){
      return (
        <div>
          <div className="content-title color-blue-3 font-size-24 mb-2">
            Επιστροφή στον Προμηθευτή
          </div>
          <p>Πρόκειται να επιστρέψετε την αίτηση στον Προμηθευτή. Παρακαλούμε εισάγετε τα σχόλιά σας.</p>
          <div className="mt-2">
            <TextAreaField
              label={'Μήνυμα'}
              placeholder={'Προσθήκη Σχολίου'}
              asterisk={true}
              name={'returnAuditorMessage'}
              id="returnAuditorMessage"
              value={returnAuditorMessage}
              maxLength={1000}
              onChange={event =>
                dispatch(
                  updateFormField({
                    group: 'auditor',
                    key: event.target.name,
                    value: event.target.value,
                  })
                )
              }
            />
          </div>
        </div>
      )
    } else if(isAuditor(user?.groups) && submitAuditor){
        return (
          <div>
            <div className="content-title color-blue-3 font-size-24 mb-2">
            Υποβολή Αξιολόγησης
          </div>Πρόκειται να εγκρίνετε την αίτηση <b>{businessKey}</b>. Η ενέργεια είναι μη αναστρέψιμη. Επιλέξτε το "Επιβεβαίωση" αν επιθυμείτε να συνεχίσετε διαφορετικά επιλέξτε "Ακύρωση".
          </div>
        )
      } else if(isAuditor(user?.groups) && rejectImplementer){
        return (
          <div>
            <div className="content-title color-blue-3 font-size-24 mb-2">
            Υποβολή Αξιολόγησης
          </div>Πρόκειται να απορρίψετε την αίτηση <b>{businessKey}</b>. Η ενέργεια είναι μη αναστρέψιμη. Επιλέξτε το "Επιβεβαίωση" αν επιθυμείτε να συνεχίσετε διαφορετικά επιλέξτε "Ακύρωση".
          </div>
        )
      } else if(isObjectionCommittee(user?.groups) && acceptObjection){
        return (
          <div>
            <div className="content-title color-blue-3 font-size-24 mb-2">
            Υποβολή Αξιολόγησης
          </div>Πρόκειται να υποβάλετε την αξιολόγησή σας στο αίτημα επανεξέτασης για την αίτηση <b>{businessKey}</b>. Η ενέργεια είναι μη αναστρέψιμη. Επιλέξτε το "Επιβεβαίωση" αν επιθυμείτε να συνεχίσετε διαφορετικά επιλέξτε "Ακύρωση".
          </div>
        )
      } else if(isObjectionCommittee(user?.groups) && rejectObjection){
        return (
          <div>
            <div className="content-title color-blue-3 font-size-24 mb-2">
            Υποβολή Αξιολόγησης
          </div>Πρόκειται να υποβάλετε την αξιολόγησή σας στο αίτημα επανεξέτασης για την αίτηση <b>{businessKey}</b>. Η ενέργεια είναι μη αναστρέψιμη. Επιλέξτε το "Επιβεβαίωση" αν επιθυμείτε να συνεχίσετε διαφορετικά επιλέξτε "Ακύρωση".
          </div>
        )
      }
  };

  const handleSubmitCheck = (() => {
    setIsVisible(false);
    if(!updateCarrierUsers){
      handleSubmit()
    }else {
      handleCarrierUsers()
    }
  })

  return (
    <>
    <Modal
      isVisible={isVisible}
      handleCancel={() => {
        setIsVisible(false)
        if (outcome === outcomes.rejectImplementer) {
          dispatch(
            updateFormField({
              group: 'carrier',
              key: 'rejectKtpReason',
              value: null,
            })
          )
          dispatch(
            updateFormField({
              group: 'carrier',
              key: "rejectKtpMessage",
              value: null,
            })
          )
        } else if(returnAuditor){
          dispatch(
            updateFormField({
              group: 'carrier',
              key: "returnAuditorMessage",
              value: null,
            })
          )
        }
      }}
      // handleConfirm={taskName==='task.name.accepted' ? handleCarrierUsers() : handleSubmit()}
      handleConfirm={handleSubmitCheck}
      width={
        outcome === outcomes.returnAuditor
          ? 600
          : 400
      }
      cancelText={returnAuditor ? 'Άκυρο' : 'Ακύρωση'}
      okText={
        isBeneficiary(user?.groups)
        ? 'Υποβολή'
          : outcome === outcomes.returnAuditor
          ? 'Επιστροφή στον Προμηθευτή'
          : 'Επιβεβαίωση'
      }
      submitDisabled={outcome === outcomes.returnAuditor && isEmpty(returnAuditorMessage) }
      formKey={formKey}
      Icon={ (outcome === outcomes.rejectImplementer)  ? WarningRed : WarningBlue }
      outcome={outcome}
      okButtonClassName={`custom-modal__submit-button ${submitDisabled ? 'is-disabled' : ''}`}
      user={user}
    >
      <div className="modal-submit-content">{renderContent()}</div>
    </Modal>
    </>
  );
};

export default SubmitModal;
